import { alpha, Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        root: {},
        text: {
            '&$shape': {
                padding: 8,
                minHeight: 40,
                minWidth: 40,
            },
        },
        outlined: {
            '&$shape': {
                padding: 7,
                minHeight: 40,
                minWidth: 40,
            },
        },
        contained: {
            '&$shape': {
                padding: 8,
                minHeight: 40,
                minWidth: 40,
            },
        },
        textSizeSmall: {
            '&$shape': {
                padding: 4,
                minHeight: 32,
                minWidth: 32,
            },
        },
        textSizeLarge: {
            '&$shape': {
                padding: 12,
                minHeight: 48,
                minWidth: 48,
            },
        },
        outlinedSizeSmall: {
            '&$shape': {
                padding: 3,
                minHeight: 32,
                minWidth: 32,
            },
        },
        outlinedSizeLarge: {
            '&$shape': {
                padding: 11,
                minHeight: 48,
                minWidth: 48,
            },
        },
        containedSizeSmall: {
            '&$shape': {
                padding: 4,
                minHeight: 32,
                minWidth: 32,
            },
        },
        containedSizeLarge: {
            '&$shape': {
                padding: 12,
                minHeight: 48,
                minWidth: 48,
            },
        },
        shape: {},
        circle: {
            borderRadius: 50,
        },
        outlinedSuccess: {
            color: theme.palette.success.main,
            border: `1px solid ${alpha(theme.palette.success.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${theme.palette.success.main}`,
                backgroundColor: alpha(theme.palette.success.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&$disabled': {
                border: `1px solid ${theme.palette.action.disabled}`,
            },
        },
        outlinedError: {
            color: theme.palette.error.main,
            border: `1px solid ${alpha(theme.palette.error.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${theme.palette.error.main}`,
                backgroundColor: alpha(theme.palette.error.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&$disabled': {
                border: `1px solid ${theme.palette.action.disabled}`,
            },
        },
        outlinedWarning: {
            color: theme.palette.warning.main,
            border: `1px solid ${alpha(theme.palette.warning.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${theme.palette.warning.main}`,
                backgroundColor: alpha(theme.palette.warning.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&$disabled': {
                border: `1px solid ${theme.palette.action.disabled}`,
            },
        },
        outlinedInfo: {
            color: theme.palette.info.main,
            border: `1px solid ${alpha(theme.palette.info.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${theme.palette.info.main}`,
                backgroundColor: alpha(theme.palette.info.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&$disabled': {
                border: `1px solid ${theme.palette.action.disabled}`,
            },
        },
        containedSuccess: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.success.dark,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.success.main,
                },
            },
        },
        containedError: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.error.dark,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.error.main,
                },
            },
        },
        containedWarning: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.warning.dark,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.warning.main,
                },
            },
        },
        containedInfo: {
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.info.dark,
                '@media (hover: none)': {
                    backgroundColor: theme.palette.info.main,
                },
            },
        },
        textSuccess: {
            color: theme.palette.success.main,
            '&:hover': {
                backgroundColor: alpha(theme.palette.success.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        textError: {
            color: theme.palette.error.main,
            '&:hover': {
                backgroundColor: alpha(theme.palette.error.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        textWarning: {
            color: theme.palette.warning.main,
            '&:hover': {
                backgroundColor: alpha(theme.palette.warning.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        textInfo: {
            color: theme.palette.info.main,
            '&:hover': {
                backgroundColor: alpha(theme.palette.info.main, theme.palette.action.hoverOpacity),
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
        },
        progress: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
        label: {
            display: 'flex',
            alignItems: 'center',
        },
        labelHidden: {
            visibility: 'hidden',
        },
        disabled: {},
        disableGutters: {},
    });

export default makeStyles(styles, { name: 'MuiButton' });
